export const secrets = {
    mapsAPIKey: "AIzaSyBmRBZvYgxyAouetrXl4Em1unQAS_yHRlw",
    web3formsAccessKey: "b1f120c0-a59f-4124-872c-bef9b7c0c8ec",
};